import type { SessionParticipant } from '@modelcast/types';

export function canAccessSidebarChat({
  startedAt,
  isHost,
  participantId,
  participants,
}: {
  startedAt: string | null;
  isHost: boolean;
  participantId: string;
  participants: SessionParticipant[];
}) {
  if (startedAt) return true;
  if (isHost) return true;

  return participants.some((participant) => (
    participant.participantId === participantId && participant.role === 'model'
  ));
}
